"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceCard = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var sanitize_1 = require("../../utils/sanitize");
var Icon_1 = require("../Icon");
var Pictogram_1 = require("../Pictogram");
var ChoiceCard = function (props) {
    var displaySelectField = props.displaySelectField, minimizedVersion = props.minimizedVersion, smallerOnMobile = props.smallerOnMobile;
    var inputAttributes = {
        className: 'sr-only',
        id: props.id,
        name: props.name,
        type: props.type,
        value: props.value,
    };
    // Add the onChange handler
    if (typeof props.onChange === 'function') {
        inputAttributes.onChange = function (e) {
            var name = props.value;
            var value = e.target.checked;
            // @ts-ignore
            props.onChange(name, value, e);
        };
        inputAttributes.checked = props.checked;
    }
    else {
        inputAttributes.defaultChecked = props.checked;
    }
    return (React.createElement("div", { className: "choicecard" + (displaySelectField ? ' new-variant' : '') + (smallerOnMobile ? ' mini-version' : '') + (minimizedVersion ? ' no-pictogram-version' : '') },
        React.createElement("input", __assign({}, inputAttributes)),
        React.createElement("label", __assign({ htmlFor: props.id }, ((!props.title || !props.description) && { className: 'label-aligned' })),
            props.pictogram && (React.createElement(Pictogram_1.Pictogram, { name: props.pictogram, alt: "" })),
            props.imageSrc && (React.createElement("img", { src: props.imageSrc, alt: "", className: "choicecard__img" })),
            props.title &&
                React.createElement("div", { className: "label-heading" }, props.title),
            props.description && !props.children && (React.createElement("p", null, props.description)),
            props.children && (React.createElement("div", { dangerouslySetInnerHTML: (0, sanitize_1.sanitize)(props.children) })),
            !(displaySelectField || minimizedVersion) &&
                React.createElement("span", { "aria-hidden": "true", className: "choicecard__cta" },
                    React.createElement("span", { className: "choicecard__cta-title" }, props.selectText || 'Choose'),
                    React.createElement(Icon_1.Icon, { symbol: "Tick24", className: "choicecard__cta-icon", type: "svginline", svgArgs: { fill1: '#ffffff' } })))));
};
exports.ChoiceCard = ChoiceCard;
exports.ChoiceCard.defaultProps = {
    checked: false,
    minimizedVersion: false,
    type: 'radio',
};
exports.ChoiceCard.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.string,
    displaySelectField: PropTypes.bool,
    id: PropTypes.string.isRequired,
    imageSrc: PropTypes.string,
    minimizedVersion: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    pictogram: PropTypes.string,
    selectText: PropTypes.string,
    smallerOnMobile: PropTypes.bool,
    title: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    value: PropTypes.string.isRequired,
};
